<script lang="ts">
  import Grid from '@components/grid.svelte'
  import { getValue } from '@statmuse/core/gamera'
  import { playerStats, players, selectedId } from './stores'

  const passingColumns = [
    {
      title: 'Passing',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'Comp',
      type: 'number',
      rowItemKey: 'COMP',
    },
    {
      title: 'Yds',
      type: 'number',
      rowItemKey: 'YDS',
    },
    {
      title: 'Avg',
      type: 'number',
      rowItemKey: 'AVG',
    },
    {
      title: 'TD',
      type: 'number',
      rowItemKey: 'TD',
    },
    {
      title: 'Int',
      type: 'number',
      rowItemKey: 'INT',
    },
    {
      title: 'Sck',
      type: 'number',
      rowItemKey: 'SACK',
    },
    {
      title: 'Rtg',
      type: 'number',
      rowItemKey: 'RTG',
    },
  ]

  const rushingColumns = [
    {
      title: 'Rushing',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'Att',
      type: 'number',
      rowItemKey: 'ATT',
    },
    {
      title: 'Yds',
      type: 'number',
      rowItemKey: 'YDS',
    },
    {
      title: 'Avg',
      type: 'number',
      rowItemKey: 'AVG',
    },
    {
      title: 'TD',
      type: 'number',
      rowItemKey: 'TD',
    },
    {
      title: 'Long',
      type: 'number',
      rowItemKey: 'LNG',
    },
  ]

  const receivingColumns = [
    {
      title: 'Receiving',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'Rec',
      type: 'number',
      rowItemKey: 'REC',
    },
    {
      title: 'Yds',
      type: 'number',
      rowItemKey: 'YDS',
    },
    {
      title: 'Avg',
      type: 'number',
      rowItemKey: 'AVG',
    },
    {
      title: 'TD',
      type: 'number',
      rowItemKey: 'TD',
    },
    {
      title: 'Long',
      type: 'number',
      rowItemKey: 'LNG',
    },
  ]

  const kickingColumns = [
    {
      title: 'Kicking',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'FG',
      type: 'number',
      rowItemKey: 'FG',
    },
    {
      title: 'XP',
      type: 'number',
      rowItemKey: 'XP',
    },
    {
      title: 'Pts',
      type: 'number',
      rowItemKey: 'PTS',
    },
    {
      title: 'Long',
      type: 'number',
      rowItemKey: 'LNG',
    },
  ]

  const kickReturnColumns = [
    {
      title: 'Kick Return',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'No',
      type: 'number',
      rowItemKey: 'NO',
    },
    {
      title: 'Yds',
      type: 'number',
      rowItemKey: 'YDS',
    },
    {
      title: 'Avg',
      type: 'number',
      rowItemKey: 'AVG',
    },
    {
      title: 'Long',
      type: 'number',
      rowItemKey: 'LNG',
    },
    {
      title: 'TD',
      type: 'number',
      rowItemKey: 'TD',
    },
  ]

  const puntReturnColumns = [
    {
      title: 'Punt Return',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'No',
      type: 'number',
      rowItemKey: 'NO',
    },
    {
      title: 'Yds',
      type: 'number',
      rowItemKey: 'YDS',
    },
    {
      title: 'Avg',
      type: 'number',
      rowItemKey: 'AVG',
    },
    {
      title: 'Long',
      type: 'number',
      rowItemKey: 'LNG',
    },
    {
      title: 'TD',
      type: 'number',
      rowItemKey: 'TD',
    },
  ]

  const fumbleColumns = [
    {
      title: 'Fumbles',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'Fum',
      type: 'number',
      rowItemKey: 'FUM',
    },
    {
      title: 'Lost',
      type: 'number',
      rowItemKey: 'LOST',
    },
    {
      title: 'Rec',
      type: 'number',
      rowItemKey: 'REC',
    },
  ]

  const puntingColumns = [
    {
      title: 'Punting',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'No',
      type: 'number',
      rowItemKey: 'NO',
    },
    {
      title: 'Yds',
      type: 'number',
      rowItemKey: 'YDS',
    },
    {
      title: 'Avg',
      type: 'number',
      rowItemKey: 'AVG',
    },
    {
      title: 'Long',
      type: 'number',
      rowItemKey: 'LNG',
    },
  ]

  const defenseColumns = [
    {
      title: 'Defense',
      type: 'string',
      rowItemKey: 'NAME',
    },
    {
      title: 'Tkl-Solo',
      type: 'number',
      rowItemKey: 'COMB',
    },
    {
      title: 'TFL',
      type: 'number',
      rowItemKey: 'TFL',
    },
    {
      title: 'Sacks',
      type: 'number',
      rowItemKey: 'SCK',
    },
    {
      title: 'Int',
      type: 'number',
      rowItemKey: 'INT',
    },
    {
      title: 'FF',
      type: 'number',
      rowItemKey: 'FF',
    },
    {
      title: 'TD',
      type: 'number',
      rowItemKey: 'TD',
    },
  ]

  $: awayStats = Object.entries($playerStats.away?.statsLookup ?? {})
  $: homeStats = Object.entries($playerStats.home?.statsLookup ?? {})

  $: awayPassingRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Passing-Attempts') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]

      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        COMP: model['Passing-Attempts']
          ? {
              display: `${model['Passing-Completions']?.display}/${model['Passing-Attempts'].display}`,
              value: getValue(model, 'Passing-Completions'),
            }
          : { display: '0/0', value: 0 },
        YDS: model['Passing-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Passing-YardsPerAttempt'] ?? { display: '0', value: 0 },
        TD: model['Passing-Touchdowns'] ?? { display: '0', value: 0 },
        INT: model['Passing-Interceptions'] ?? { display: '0', value: 0 },
        SACK: model['Passing-Sacks']
          ? {
              display: `${model['Passing-Sacks']?.display}-${model['Passing-SackYards']?.display}`,
              value: getValue(model, 'Passing-Sacks'),
            }
          : { display: '0-0', value: 0 },
        RTG: model['Passing-Rating'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: homePassingRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Passing-Attempts') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]

      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        COMP: model['Passing-Attempts']
          ? {
              display: `${model['Passing-Completions']?.display}/${model['Passing-Attempts'].display}`,
              value: getValue(model, 'Passing-Completions'),
            }
          : { display: '0/0', value: 0 },
        YDS: model['Passing-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Passing-YardsPerAttempt'] ?? { display: '0', value: 0 },
        TD: model['Passing-Touchdowns'] ?? { display: '0', value: 0 },
        INT: model['Passing-Interceptions'] ?? { display: '0', value: 0 },
        SACK: model['Passing-Sacks']
          ? {
              display: `${model['Passing-Sacks']?.display}-${model['Passing-SackYards']?.display}`,
              value: getValue(model, 'Passing-Sacks'),
            }
          : { display: '0-0', value: 0 },
        RTG: model['Passing-Rating'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: awayRushingRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Rushing-Attempts') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        ATT: model['Rushing-Attempts'] ?? { display: '0', value: 0 },
        YDS: model['Rushing-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Rushing-YardsPerAttempt'] ?? { display: '0', value: 0 },
        TD: model['Rushing-Touchdowns'] ?? { display: '0', value: 0 },
        LNG: model['Rushing-LongestRush'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: homeRushingRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Rushing-Attempts') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        ATT: model['Rushing-Attempts'] ?? { display: '0', value: 0 },
        YDS: model['Rushing-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Rushing-YardsPerAttempt'] ?? { display: '0', value: 0 },
        TD: model['Rushing-Touchdowns'] ?? { display: '0', value: 0 },
        LNG: model['Rushing-LongestRush'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: awayReceivingRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Receiving-Targets') > 0 ||
          getValue(model, 'Receiving-Yards') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        REC: model['Receiving-Targets']
          ? {
              display: `${model['Receiving-Receptions']?.display}/${model['Receiving-Targets']?.display}`,
              value: getValue(model, 'Receiving-Receptions'),
            }
          : { display: '0/0', value: 0 },
        YDS: model['Receiving-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Receiving-YardsPerReception'] ?? { display: '0', value: 0 },
        TD: model['Receiving-Touchdowns'] ?? { display: '0', value: 0 },
        LNG: model['Receiving-LongestReception'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: homeReceivingRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Receiving-Targets') > 0 ||
          getValue(model, 'Receiving-Yards') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        REC: model['Receiving-Targets']
          ? {
              display: `${model['Receiving-Receptions']?.display}/${model['Receiving-Targets']?.display}`,
              value: getValue(model, 'Receiving-Receptions'),
            }
          : { display: '0/0', value: 0 },
        YDS: model['Receiving-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Receiving-YardsPerReception'] ?? { display: '0', value: 0 },
        TD: model['Receiving-Touchdowns'] ?? { display: '0', value: 0 },
        LNG: model['Receiving-LongestReception'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: awayKickingRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Kicking-FieldGoalsAttempted') > 0 ||
          getValue(model, 'Kicking-ExtraPointsAttempted') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        FG: model['Kicking-FieldGoalsAttempted']
          ? {
              display: `${model['Kicking-FieldGoalsMade']?.display}/${model['Kicking-FieldGoalsAttempted']?.display}`,
              value: getValue(model, 'Kicking-FieldGoalsMade'),
            }
          : { display: '0/0', value: 0 },
        LNG: model['Kicking-LongestFieldGoal'] ?? { display: '0', value: 0 },
        XP: model['Kicking-ExtraPointsAttempted']
          ? {
              display: `${model['Kicking-ExtraPointsMade']?.display}/${model['Kicking-ExtraPointsAttempted']?.display}`,
              value: getValue(model, 'Kicking-ExtraPointsMade'),
            }
          : { display: '0/0', value: 0 },
        PTS: model['Kicking-KickingPoints'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.PTS.value - a.PTS.value)

  $: homeKickingRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Kicking-FieldGoalsAttempted') > 0 ||
          getValue(model, 'Kicking-ExtraPointsAttempted') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        FG: model['Kicking-FieldGoalsAttempted']
          ? {
              display: `${model['Kicking-FieldGoalsMade']?.display}/${model['Kicking-FieldGoalsAttempted']?.display}`,
              value: getValue(model, 'Kicking-FieldGoalsMade'),
            }
          : { display: '0/0', value: 0 },
        LNG: model['Kicking-LongestFieldGoal'] ?? { display: '0', value: 0 },
        XP: model['Kicking-ExtraPointsAttempted']
          ? {
              display: `${model['Kicking-ExtraPointsMade']?.display}/${model['Kicking-ExtraPointsAttempted']?.display}`,
              value: getValue(model, 'Kicking-ExtraPointsMade'),
            }
          : { display: '0/0', value: 0 },
        PTS: model['Kicking-KickingPoints'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.PTS.value - a.PTS.value)

  $: awayKickReturnRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Kickoff-Returns') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        NO: model['Kickoff-Returns'] ?? { display: '0', value: 0 },
        YDS: model['Kickoff-ReturnYards'] ?? { display: '0', value: 0 },
        AVG: model['Kickoff-ReturnYardsAverage'] ?? { display: '0', value: 0 },
        LNG: model['Kickoff-LongestReturns'] ?? { display: '0', value: 0 },
        TD: model['Kickoff-ReturnTouchdowns'] ?? { display: '0', value: 0 },
      }
    })

  $: homeKickReturnRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Kickoff-Returns') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        NO: model['Kickoff-Returns'] ?? { display: '0', value: 0 },
        YDS: model['Kickoff-ReturnYards'] ?? { display: '0', value: 0 },
        AVG: model['Kickoff-ReturnYardsAverage'] ?? { display: '0', value: 0 },
        LNG: model['Kickoff-LongestReturns'] ?? { display: '0', value: 0 },
        TD: model['Kickoff-ReturnTouchdowns'] ?? { display: '0', value: 0 },
      }
    })

  $: awayPuntReturnRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'PuntReturn-PuntReturns') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        NO: model['PuntReturn-PuntReturns'] ?? { display: '0', value: 0 },
        YDS: model['PuntReturn-Yards'] ?? { display: '0', value: 0 },
        AVG: model['PuntReturn-YardsPerPuntReturn'] ?? {
          display: '0',
          value: 0,
        },
        LNG: model['PuntReturn-LongestReturn'] ?? { display: '0', value: 0 },
        TD: model['PuntReturn-Touchdowns'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: homePuntReturnRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'PuntReturn-PuntReturns') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        NO: model['PuntReturn-PuntReturns'] ?? { display: '0', value: 0 },
        YDS: model['PuntReturn-Yards'] ?? { display: '0', value: 0 },
        AVG: model['PuntReturn-YardsPerPuntReturn'] ?? {
          display: '0',
          value: 0,
        },
        LNG: model['PuntReturn-LongestReturn'] ?? { display: '0', value: 0 },
        TD: model['PuntReturn-Touchdowns'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.YDS.value - a.YDS.value)

  $: awayFumbleRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Fumbles') > 0 ||
          getValue(model, 'FumblesLost') > 0 ||
          getValue(model, 'FumbleRecoveries') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        FUM: model['Fumbles'] ?? { display: '0', value: 0 },
        LOST: model['FumblesLost'] ?? { display: '0', value: 0 },
        REC: model['FumbleRecoveries'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.FUM.value - a.FUM.value)

  $: homeFumbleRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Fumbles') > 0 ||
          getValue(model, 'FumblesLost') > 0 ||
          getValue(model, 'FumbleRecoveries') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        FUM: model['Fumbles'] ?? { display: '0', value: 0 },
        LOST: model['FumblesLost'] ?? { display: '0', value: 0 },
        REC: model['FumbleRecoveries'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.FUM.value - a.FUM.value)

  $: awayPuntingRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Punting-Punts') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        NO: model['Punting-Punts'] ?? { display: '0', value: 0 },
        YDS: model['Punting-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Punting-YardsAverage'] ?? { display: '0', value: 0 },
        LNG: model['Punting-LongestPunt'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.NO.value - a.NO.value)

  $: homePuntingRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') && getValue(model, 'Punting-Punts') > 0,
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        NO: model['Punting-Punts'] ?? { display: '0', value: 0 },
        YDS: model['Punting-Yards'] ?? { display: '0', value: 0 },
        AVG: model['Punting-YardsAverage'] ?? { display: '0', value: 0 },
        LNG: model['Punting-LongestPunt'] ?? { display: '0', value: 0 },
      }
    })
    .sort((a, b) => b.NO.value - a.NO.value)

  $: awayDefenseRows = awayStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Defensive-CombinedTackles') > 0 ||
          getValue(model, 'Defensive-Interceptions') > 0 ||
          getValue(model, 'Defensive-Sacks') > 0 ||
          getValue(model, 'Defensive-ForcedFumbles') > 0 ||
          getValue(model, 'Defensive-InterceptionTouchdowns') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        COMB: model['Defensive-CombinedTackles']
          ? {
              display: `${model['Defensive-CombinedTackles'].display}-${model['Defensive-Tackles']?.display}`,
              value: getValue(model, 'Defensive-CombinedTackles'),
            }
          : { display: '0-0', value: 0 },
        TFL: model['Defensive-TacklesForLoss'] ?? { display: '0', value: 0 },
        SCK: model['Defensive-Sacks'] ?? { display: '0', value: 0 },
        INT: model['Defensive-Interceptions'] ?? { display: '0', value: 0 },
        FF: model['Defensive-ForcedFumbles'] ?? { display: '0', value: 0 },
        TD: model['Defensive-InterceptionTouchdowns'] ?? {
          display: '0',
          value: 0,
        },
      }
    })
    .sort((a, b) => b.COMB.value - a.COMB.value)

  $: homeDefenseRows = homeStats
    .filter(
      ([key, model]) =>
        key.includes('p-') &&
        (getValue(model, 'Defensive-CombinedTackles') > 0 ||
          getValue(model, 'Defensive-Interceptions') > 0 ||
          getValue(model, 'Defensive-Sacks') > 0 ||
          getValue(model, 'Defensive-ForcedFumbles') > 0 ||
          getValue(model, 'Defensive-InterceptionTouchdowns') > 0),
    )
    .map(([key, model]) => {
      const player = $players[key.replace('p-', '').split(':')[2]]
      return {
        NAME: {
          display: player?.longName,
          value: player?.longName,
          meta: {
            id: player?.id,
            shortDisplay: player?.shortName,
            position: player?.uniformNumber
              ? `#${player.uniformNumber}`
              : undefined,
          },
        },
        COMB: model['Defensive-CombinedTackles']
          ? {
              display: `${model['Defensive-CombinedTackles'].display}-${model['Defensive-Tackles']?.display}`,
              value: getValue(model, 'Defensive-CombinedTackles'),
            }
          : { display: '0-0', value: 0 },
        TFL: model['Defensive-TacklesForLoss'] ?? { display: '0', value: 0 },
        SCK: model['Defensive-Sacks'] ?? { display: '0', value: 0 },
        INT: model['Defensive-Interceptions'] ?? { display: '0', value: 0 },
        FF: model['Defensive-ForcedFumbles'] ?? { display: '0', value: 0 },
        TD: model['Defensive-InterceptionTouchdowns'] ?? {
          display: '0',
          value: 0,
        },
      }
    })
    .sort((a, b) => b.COMB.value - a.COMB.value)
</script>

{#if awayPassingRows.length > 0 || homePassingRows.length > 0}
  {#if awayPassingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayPassingRows, columns: passingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homePassingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homePassingRows, columns: passingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayRushingRows.length > 0 || homeRushingRows.length > 0}
  {#if awayRushingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayRushingRows, columns: rushingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homeRushingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homeRushingRows, columns: rushingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayReceivingRows.length > 0 || homeReceivingRows.length > 0}
  {#if awayReceivingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayReceivingRows, columns: receivingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homeReceivingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homeReceivingRows, columns: receivingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayFumbleRows.length > 0 || homeFumbleRows.length > 0}
  {#if awayFumbleRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayFumbleRows, columns: fumbleColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homeFumbleRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homeFumbleRows, columns: fumbleColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayDefenseRows.length > 0 || homeDefenseRows.length > 0}
  {#if awayDefenseRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayDefenseRows, columns: defenseColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homeDefenseRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homeDefenseRows, columns: defenseColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayKickingRows.length > 0 || homeKickingRows.length > 0}
  {#if awayKickingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayKickingRows, columns: kickingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homeKickingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homeKickingRows, columns: kickingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayPuntingRows.length > 0 || homePuntingRows.length > 0}
  {#if awayPuntingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayPuntingRows, columns: puntingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homePuntingRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homePuntingRows, columns: puntingColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayKickReturnRows.length > 0 || homeKickReturnRows.length > 0}
  {#if awayKickReturnRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayKickReturnRows, columns: kickReturnColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homeKickReturnRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homeKickReturnRows, columns: kickReturnColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}

{#if awayPuntReturnRows.length > 0 || homePuntReturnRows.length > 0}
  {#if awayPuntReturnRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: awayPuntReturnRows, columns: puntReturnColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'away',
        })}
    />
  {:else}
    <div></div>
  {/if}

  {#if homePuntReturnRows.length > 0}
    <Grid
      textInherit
      disableSort
      data={{ rows: homePuntReturnRows, columns: puntReturnColumns }}
      stickyColumns={['NAME']}
      onRowClick={(row) => () =>
        selectedId.set({
          id: row.NAME?.meta?.id ?? 0,
          alignment: 'home',
        })}
    />
  {:else}
    <div></div>
  {/if}
{/if}
